import { generateClassName, getColorVariantFromBackground } from '@klv/shared/utils/functions';
import Button from '@klv/atoms/button';
import Image from '@klv/atoms/image';

import * as s from './styles/galleryCard.module.css';

import type { IGatsbyImageData } from 'gatsby-plugin-image';
import type { IGalleryCard } from './types';

const GalleryCard = ({
  backgroundColor,
  buttons,
  cardButtonText,
  image,
  innerRef,
  onFocus,
  showTitle,
  title,
  ...rest
}: IGalleryCard & React.HTMLAttributes<HTMLDivElement>) => {
  const ariaLabelPrefix = `${cardButtonText}: ${title}`;
  const colorVariant = getColorVariantFromBackground(backgroundColor);

  return (
    <div className={s.galleryCard} ref={innerRef} {...rest}>
      <Button
        className={s.cardLink}
        aria-label={buttons[0].openInNewTab ? `${ariaLabelPrefix} (opens in a new tab)` : ariaLabelPrefix}
        url={buttons[0].url}
        variant="none"
        openInNewTab={buttons[0].openInNewTab}
        onFocus={onFocus}
      >
        <>
          <div className={s.imageContainer}>
            <Image
              className={s.imageWrapper}
              imageData={image?.gatsbyImage as IGatsbyImageData}
              altText={image?.altText}
            />
            <div className={s.svgWrapper}>
              <svg preserveAspectRatio="none" viewBox="0 0 380 450">
                <rect x="2" y="2" rx="9" strokeWidth="4" />
              </svg>
            </div>
            <div className={s.hoverContainer}>
              <Button
                className={s.button}
                text={cardButtonText}
                setTabIndex={-1}
                buttonColor="light"
              />
            </div>
          </div>
          {showTitle && (
            <div className={generateClassName([s.title, s[colorVariant], 'p2'])}>
              {title}
            </div>
          )}
        </>
      </Button>
    </div>
  );
};
export default GalleryCard;
